import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatPrice = (price: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(price);
};

/**
 * Format sequence price, showing "Free Download" for $0.00 sequences
 */
export const formatSequencePrice = (price: number, context: 'display' | 'button' = 'display'): string => {
  if (price === 0) {
    return context === 'button' ? 'Free Download' : 'Free Download';
  }
  return `$${price.toFixed(2)}`;
};

export const formatSchedule = (schedule: any) => {
  if (!schedule) {
    return "No schedule available";
  }
  
  try {
    const { start_date, end_date, days, hours } = schedule;
    const formattedDays = Array.isArray(days) && days.length > 0 
      ? days.join(', ') 
      : "All days";
    
    const timeRange = hours 
      ? `${hours.start} - ${hours.end}` 
      : "No specific hours";
    
    return `${start_date} - ${end_date} • ${formattedDays} • ${timeRange}`;
  } catch (error) {
    console.error("Error formatting schedule:", error);
    return "Schedule information unavailable";
  }
};

/**
 * Format holiday names for display
 */
export const formatHolidayName = (holiday: string): string => {
  switch (holiday) {
    case 'FourthOfJuly':
      return 'Fourth of July';
    case 'NewYearsEve':
      return "New Year's Eve";
    case 'StPatricksDay':
      return "St. Patrick's Day";
    default:
      return holiday;
  }
};

/**
 * Format duration from seconds to minutes:seconds format
 */
export const formatDuration = (seconds?: number, milliseconds?: number): string => {
  const totalSeconds = seconds || (milliseconds ? Math.floor(milliseconds / 1000) : 0);
  if (!totalSeconds) return 'Unknown';
  
  const minutes = Math.floor(totalSeconds / 60);
  const remainingSeconds = totalSeconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};
